<template>
  <ion-page class="nc-page">
    <slot />
  </ion-page>
</template>

<script>
export default {
  name: 'NcPage',
};
</script>

<style scoped>
.nc-page {
  display: flex;
  flex-direction: column;
  background: var(--nc-bg-page);
  color: var(--nc-text);
  font-family: var(--nc-font-family);
  overflow: hidden;
  contain: layout size style;
}
</style>
